import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import ClearStore from '../components/ClearStore'
import NavBar from '../components/NavBar'



const ClearStorePage = () => {
    return (
        <div>
            <Header/>
            <NavBar />
            <ClearStore/>
            <Footer/>
        </div>
    )
}

export default ClearStorePage
